<template>
  <span>{{ amount }}</span>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    seatCountDetail: {
      required: true,
      type: Object
    },
    totalOnly: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    amount: function () {
      return this.totalOnly ? this.total : this.detail
    },
    detail: function () {
      const a = Object.entries(this.seatCountDetail).map(([key, value]) => {
        let label
        switch(key){
          case 'adult':
            label = this.$t('tour_fare_labels_adult')
            break
          case 'child':
            label = this.$t('tour_fare_labels_child')
            break
          case 'infant':
            label = this.$t('tour_fare_labels_infant')
            break
          case 'baby':
            label = this.$t('tour_fare_labels_baby')
            break
        }
        if (value > 0) return `${label}${value}`+"$t('tour_persons')"
      }).filter(v => v)
      return a.join('、')
    },
    total: function () {
      return _.sum(_.values(this.seatCountDetail))
    }
  }
}
</script>
